import { type HttpClient } from '../useHttpClient';

type KpiAssignee = {
  userId?: number;
  unitId?: number;
  kpiId: number;
};

type RequestSchema = {
  data: KpiAssignee[];
};

export const removeKpiAssignees =
  (httpClient: HttpClient) => async (request: RequestSchema) => {
    await httpClient.api('/admin/kpi-assignees', {
      method: 'DELETE',
      body: JSON.stringify(request),
    });
  };

export const addKpiAssignees =
  (httpClient: HttpClient) => async (request: RequestSchema) => {
    await httpClient.api('/admin/kpi-assignees', {
      method: 'POST',
      body: JSON.stringify(request),
    });
  };
